import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "addUserModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Хэрэглэгч нэмэх", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Банк")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("ББСБ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ХЗХ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Бусад")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Монголбанкны хэрэглэгч мөн эсэх ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_14 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearField && _ctx.clearField(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            model: this.modalForm,
            ref: "addorgmodalref",
            "label-width": "180px",
            "label-position": "left",
            size: "mini",
            rules: _ctx.useraddmodalrules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Төрөл:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.modalForm.orgtype,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalForm.orgtype) = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => {
                  this.modalForm.selectValOrg = '';
                  this.modalForm.selectorgbranchcode = '';
                })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: "03" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "04" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "05" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio_button, { label: "06" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Байгууллага:",
                prop: "selectValOrg",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.modalForm.selectValOrg,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalForm.selectValOrg) = $event)),
                    placeholder: "Байгууллага сонгох",
                    filterable: "",
                    size: "mini",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (this.modalForm.selectorgbranchcode = '')),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.modalForm.selectOrgList.filter(data => {
                    return (
                      data.selectOrgTypeCode.trim() ===
                      this.modalForm.orgtype.trim()
                    );
                  }), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.selectValOrg,
                          label: item.selectLabelOrg,
                          value: item.selectValOrg
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (this.modalForm.selectValOrg.trim() !== '')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "Салбар:",
                    prop: "selectorgbranchcode",
                    "label-width": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.modalForm.selectorgbranchcode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalForm.selectorgbranchcode) = $event)),
                        filterable: "",
                        placeholder: "Салбар сонгох",
                        size: "mini",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.modalForm.selectOrgBranchList.filter(
                    data => {
                      if (
                        this.modalForm.selectValOrg.trim() ===
                        data.selectorgcode.trim()
                      )
                        return data;
                    }
                  ), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.selectorgbranchcode,
                              label: item.selectbranchname,
                              value: item.selectorgbranchcode
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "Нэвтрэх нэр:",
                prop: "username",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.username,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalForm.username) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Нэр:",
                prop: "name2",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.name2,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalForm.name2) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Цахим шуудан:",
                prop: "email",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.email,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalForm.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "IP хаяг:",
                prop: "ipaddress",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.ipaddress,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalForm.ipaddress) = $event)),
                    placeholder: "0.0.0.0"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Үүрэг:",
                prop: "roleid",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "mini",
                    modelValue: _ctx.modalForm.roleid,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalForm.roleid) = $event)),
                    filterable: "",
                    placeholder: "Үүрэг сонгох",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.computedRoleList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.roleid,
                          label: item.rolename,
                          value: item.roleid
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Утасны дугаар:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.phone,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalForm.phone) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Нууц үг:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.pass1,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalForm.pass1) = $event)),
                    "show-password": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "XML нийлүүлэх нууц үг:",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.modalForm.pass2,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalForm.pass2) = $event)),
                    "show-password": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "ismbuser",
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _ctx.modalForm.ismbuser,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalForm.ismbuser) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_row, {
            type: "flex",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                loading: _ctx.adduserbuttonloader,
                onClick: _cache[15] || (_cache[15] = ($event: any) => {
                _ctx.saveUser();
                _ctx.formSubmit();
              })
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                ref: "hidemodalbutton",
                size: "mini",
                class: "col-lg-3",
                "data-bs-dismiss": "modal",
                onClick: _ctx.clearField
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}